import { useEffect } from "react";
import { getModuleRoute } from "./moduleRoutes";
import { useNavigate } from "react-router-dom";
import { MASTER_MENU_TYPES } from "../constants/masterMenus";

export const getShortcutPath = ({ parentPath, childPath, code }) => {
  const subtype =
    parentPath === "master" ? MASTER_MENU_TYPES[code]?.subTypes[0]?.name : null;
  return `/${parentPath}/${childPath}${subtype ? `/${subtype.replace(/\s+/g, "-")}` : ""}`;
};

const useShortcutNavigation = () => {
  const navigate = useNavigate();
  useEffect(() => {
    let keySequence = "";
    let isInCommandMode = false;
    let timeoutId = null;
    let maxCodeLength = 0;

    const sidebarItems = JSON.parse(
      localStorage.getItem("sidebarItems") || "[]",
    );

    sidebarItems.forEach((parent) => {
      parent.child_menu.forEach((child) => {
        if (child.menu_code.length > maxCodeLength) {
          maxCodeLength = child.menu_code.length;
        }
      });
    });

    const resetCommandMode = () => {
      isInCommandMode = false;
      keySequence = "";
      if (timeoutId) clearTimeout(timeoutId);
    };

    const navigateToCode = (code) => {
      for (const parent of sidebarItems) {
        const child = (parent.child_menu || []).find(
          (item) => item.menu_code?.toUpperCase() === code,
        );
        if (!child) continue;
        const moduleRoute = getModuleRoute(child);
        if (moduleRoute) {
          window.location.href = moduleRoute;
          resetCommandMode();
          return true;
        }
        const parentPath = parent.display_title
          .toLowerCase()
          .replace(/ /g, "-");
        const childPath = child.display_title.toLowerCase().replace(/ /g, "-");
        sessionStorage.setItem("transactionCode", child.menu_code);
        if (["Graphical Reports", "Reports"].includes(parent.display_title)) {
          sessionStorage.setItem("tab", parentPath);
        }
        const path = getShortcutPath({
          parentPath,
          childPath,
          code: child.menu_code,
        });
        const masterType =
          parentPath === "master" ? MASTER_MENU_TYPES[child.menu_code] : null;
        if (masterType?.subTypes.length) {
          navigate(path, {
            state: {
              transactionCode: child.menu_code,
              masterSubType: masterType.subTypes[0].name,
              isMasterSubType: true,
              masterTypeName: child.name || masterType.name,
            },
          });
        } else {
          window.location.href = path;
        }
        resetCommandMode();
        return true;
      }
      return false;
    };

    const handlePaste = (event) => {
      if (
        event.target instanceof Element &&
        event.target.closest(
          "input, textarea, select, [contenteditable]:not([contenteditable='false'])",
        )
      )
        return;
      const text = event.clipboardData?.getData("text/plain").trim();
      if (
        text?.startsWith("`") &&
        navigateToCode(text.slice(1).toUpperCase())
      ) {
        event.preventDefault();
      }
    };

    const handleKeyDown = (e) => {
      if (e.ctrlKey || e.metaKey || e.altKey) return;
      if (e.key === "`") {
        e.preventDefault();
        isInCommandMode = true;
        keySequence = "";

        timeoutId = setTimeout(() => {
          resetCommandMode();
        }, 5000);
        return;
      }

      if (isInCommandMode) {
        e.preventDefault();
        keySequence += e.key.toUpperCase();

        navigateToCode(keySequence);

        if (keySequence.length > maxCodeLength) {
          resetCommandMode();
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("paste", handlePaste);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("paste", handlePaste);
      resetCommandMode();
    };
  }, [navigate]);
};

export default useShortcutNavigation;
